'use client';

import { Button, Heading } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { useState } from 'react';

import { BrandContentScript, useSalsify } from '@libs/common-next';

import './BrandContent.scss';

export type BrandContentProps = {
    className?: string;
    productId: string;
    salsifyClientId: string;
    salsifyIdType: string;
};

export function BrandContent({ salsifyClientId, salsifyIdType, productId }: Readonly<BrandContentProps>) {
    const [showAll, setShowAll] = useState(false);
    const { salsifyFound, webCollageFound, initializeWebcollage } = useSalsify({
        salsifyClientId,
        salsifyIdType,
        productId,
    });

    // Display logic
    const showText = showAll ? 'Show less' : 'Show more';

    return (
        <>
            <BrandContentScript initializeWebcollage={initializeWebcollage} />
            <div
                data-testid="brand-content"
                className={cn('sparky-l-container', 'brand-content-wrapper', {
                    hide: !salsifyFound && !webCollageFound,
                })}
            >
                <Heading tagName="h2" size="title">
                    From the manufacturer
                </Heading>
                <div className={cn('show-more-container', { open: showAll })}>
                    {salsifyFound && <div id="salsify-target" />}
                    {webCollageFound && <div id="wc-power-page" />}
                </div>
                <Button
                    onClick={() => {
                        setShowAll(!showAll);
                        return false;
                    }}
                    text={showText}
                />
            </div>
        </>
    );
}
